import { toast } from "react-toastify"
import React, { useEffect, useState } from "react"

import { IDAM } from "../../api/Registry"
import { APPLICATION } from "../../utils/Constants"
import HttpServices from "../../services/HttpServices"
import { RouteHydration } from "../../utils/Helpers"
import { Checkbox } from "../../components/utils/Checkbox"
import { DynamicModal } from "../../lib/fragments/DynamicModal"
import { FloatingInput } from "../../components/utils/FloatingInput"
import { FloatingTextArea } from "../../components/utils/FloatingTextArea"
import { G_onInputBlurHandler, G_onInputChangeHandler } from "../../components/utils/InputHandlers"

export const CreateOrEditAttributeGroup = ({ show, showOrHide, onComplete, cargo }) => {
    const [state, setstate] = useState({
        posting: false,
        httpStatus: 200,
        status: 'pending',
        data: {
            group: null,
        },
        input: {
            group_label: '',
            hint: '',
            add_another: '',
        }, errors: {
            group_label: '',
            hint: '',
        }
    })

    const isCreate = cargo.action === 'create';
    const modalTitle = `${isCreate ? 'Create' : 'Edit'} Attribute Group`;
    const actionLabel = isCreate ? 'Create' : 'Update';

    const getAttributeGroupDetails = async () => {
        let { data, input, httpStatus, status } = state

        try {
            const attributeGroupRoute = [":group"]
                .reduce((route, param, index) =>
                    RouteHydration(route, param, [cargo.uuid][index]),
                    IDAM.ATTR_GROUP_DETAIL
                );

            const response: any = await HttpServices.httpGet(attributeGroupRoute)
            httpStatus = response.status

            if (httpStatus === 200) {
                const payload: any = response.data.payload
                data.group = payload.group

                input.group_label = data.group.e
                input.hint = data.group.t

                status = 'fulfilled'
            } else {
                status = 'rejected'
            }
        } catch (error) {
            httpStatus = 500
            status = 'rejected'
        }

        setstate((prev: any) => ({
            ...prev,
            data,
            input,
            httpStatus,
            status
        }))
    }

    const fulfillStatusForCreateAction = () => {
        setTimeout(() => {
            setstate((prev: any) => ({
                ...prev,
                status: 'fulfilled'
            }))
        }, 500);
    }

    useEffect(() => {
        if (show) {
            cargo.action === 'edit'
                ? getAttributeGroupDetails()
                : fulfillStatusForCreateAction()
        }
    }, [show, cargo])

    const onCloseModal = async () => {
        showOrHide()

        // Reset the state on close
        setTimeout(() => {
            setstate((prev: any) => ({
                ...prev,
                posting: false,
                httpStatus: 200,
                status: 'pending',
                data: {
                    group: null
                },
                input: {
                    ...prev.input,
                    group_label: '',
                    add_another: '',
                    hint: '',
                },
                errors: {
                    ...prev.errors,
                    group_label: '',
                    hint: '',
                }
            }))
        }, 300)
    }

    const onChangeHandler = (e: any) => {
        let { posting, input, errors } = state
        if (posting) return

        let output: any = G_onInputChangeHandler(e)

        const updatedInput = {
            ...input,
            [e.target.name]: output.value
        };

        const updatedErrors = {
            ...errors,
            [e.target.name]: output.error
        };

        setstate((prev: any) => ({
            ...prev,
            input: updatedInput,
            errors: updatedErrors,
        }));
    }

    const onInputBlur = (e: any) => {
        let { posting, input, errors } = state
        if (posting) return

        let output: any = G_onInputBlurHandler(e, '')

        const updatedInput = {
            ...input,
            [e.target.name]: output.value
        };

        const updatedErrors = {
            ...errors,
            [e.target.name]: output.error
        };

        setstate((prev: any) => ({
            ...prev,
            input: updatedInput,
            errors: updatedErrors,
        }));

    }

    const attributeGroupFormHandler = (e: any) => {
        e.preventDefault()

        let { posting, input } = state
        if (posting) return

        let valid = true
        const inputKeys = Object.keys(input)

        inputKeys.forEach((inputKey: any) => {
            try {
                let oTarget = e.target[inputKey]

                let event: any = {
                    target: {
                        name: oTarget.name,
                        required: oTarget.required,
                        value: oTarget.value.trim(),
                    }
                }

                onInputBlur(event)
            } catch (error) {
                // console.log(error);
                // Override error
            }
        })

        let { errors } = state
        const errorArray = Object.keys(errors)

        errorArray.forEach((errorObject: any) => {
            if (errors[errorObject].length > 0) {
                valid = false
            }
        })

        if (valid) {
            setstate((prev: any) => ({
                ...prev,
                posting: true,
            }))

            attributeGroupDataHandler()
        }
    }

    const attributeGroupDataHandler = async () => {
        let { input, errors, httpStatus } = state

        try {
            let formData = new FormData()
            formData.append('group_label', input.group_label)
            formData.append('hint', input.hint)

            const attributeGroupRoute = cargo.action === 'create'
                ? IDAM.ATTR_GROUPS
                : [":group"]
                    .reduce((route, param, index) =>
                        RouteHydration(route, param, [cargo.uuid][index]),
                        IDAM.ATTR_GROUP_DETAIL
                    )

            const response: any = cargo.action === 'create'
                ? await HttpServices.httpPost(attributeGroupRoute, formData)
                : await HttpServices.httpPut(attributeGroupRoute, formData);

            httpStatus = response.status

            if (httpStatus === 200) {
                if (input.add_another === 'Y') {
                    setstate((prev: any) => ({
                        ...prev,
                        input: {
                            ...prev.input,
                            group_label: '',
                            hint: '',
                        }
                    }));
                } else {
                    onCloseModal()
                }

                onComplete()
            } else {
                if (httpStatus === 422) {
                    Object.entries(response.data).forEach(([field, errorMessages]) => {
                        const submissionErrors = {
                            ...errors,
                            [field]: errorMessages
                        };

                        setstate((prev: any) => ({
                            ...prev,
                            errors: submissionErrors,
                        }));
                    });
                } else {
                    toast.error(APPLICATION.ERR_MSG);
                }
            }
        } catch (error) {
            toast.error(APPLICATION.ERR_MSG);
        }

        setstate((prev: any) => ({
            ...prev,
            posting: false,
            httpStatus
        }));
    }

    return (
        <React.Fragment>
            <DynamicModal
                size={'md'}
                show={show}
                title={modalTitle}
                posting={state.posting}
                status={state.status}
                actionName={actionLabel}
                showOrHide={onCloseModal}
                onSubmit={attributeGroupFormHandler}
                content={
                    <>
                        <header className="w-full mb-2 header-title flex flex-col md:gap-y-1 gap-y-1">
                            <p className="text-sm pb-5 text-slate-600 dark:text-slate-400">
                                Grouping helps structure attribute management and improve clarity across user configurations.
                            </p>
                        </header>

                        <div className="w-full pb-4">
                            <FloatingInput
                                css={"md:w-72"}
                                required={true}
                                name={"group_label"}
                                posting={state.posting}
                                label={"Group Label *"}
                                blurHandler={onInputBlur}
                                changeHandler={onChangeHandler}
                                value={state.input.group_label}
                                error={state.errors.group_label}
                            />
                        </div>

                        <div className="w-full pb-3">
                            <FloatingTextArea
                                required={false}
                                name={"hint"}
                                posting={state.posting}
                                label={
                                    <span className="flex items-center gap-1">
                                        Hint <span className="text-xs text-gray-500 dark:text-gray-400">(Optional)</span>
                                    </span>
                                }
                                blurHandler={onInputBlur}
                                changeHandler={onChangeHandler}
                                value={state.input.hint}
                                error={state.errors.hint}
                            />

                            <p className="text-xs pb-4 pt-1 text-slate-500 dark:text-slate-400">
                                A brief description for others to understand the purpose of this group
                            </p>
                        </div>

                        {
                            cargo.action === 'create' && (
                                <Checkbox
                                    value={state.input.add_another}
                                    name={'add_another'}
                                    disabled={false}
                                    posting={state.posting}
                                    checked={state.input.add_another === 'Y'}
                                    required={false}
                                    changeHandler={onChangeHandler}
                                    label={
                                        <>
                                            <div className="text-slate-600 dark:text-slate-500">
                                                <span className="block">Create another</span>
                                            </div>
                                        </>
                                    }
                                />
                            )
                        }

                    </>
                }
            />
        </React.Fragment>
    )
}